import { ColumnCount } from '@hh.ru/magritte-ui-grid';

export const enum AccountsControlHeader {
    CreatedAt = 'createdAt',
    ExpiredDate = 'expiredDate',
    Accounts = 'accounts',
    Users = 'users',
    RealBalance = 'realBalance',
    BonusBalance = 'bonusBalance',
}

export const ACCOUNTS_CONTROL_HEADERS = [
    AccountsControlHeader.CreatedAt,
    AccountsControlHeader.ExpiredDate,
    AccountsControlHeader.Accounts,
    AccountsControlHeader.Users,
    AccountsControlHeader.RealBalance,
    AccountsControlHeader.BonusBalance,
];

type ColumnsSizes = { m: ColumnCount; width?: never } | { m?: never; width: number };

export const ACCOUNT_COLUMN_SIZE: Record<AccountsControlHeader, ColumnsSizes> = {
    [AccountsControlHeader.CreatedAt]: {
        width: 140,
    },
    [AccountsControlHeader.ExpiredDate]: {
        width: 220,
    },
    [AccountsControlHeader.Accounts]: {
        m: 1,
    },
    [AccountsControlHeader.Users]: {
        m: 4,
    },
    [AccountsControlHeader.RealBalance]: {
        m: 1,
    },
    [AccountsControlHeader.BonusBalance]: {
        m: 1,
    },
};

export const ACCOUNTS_CONTROL_SORT_HEADERS = [AccountsControlHeader.CreatedAt, AccountsControlHeader.ExpiredDate];

export const ACCOUNTS_CONTROL_MAX_USERS = 7;

export const ACCOUNTS_USER_TAG_LIST_MAX_USERS = 8;

export const enum AccountCreateError {
    EmptyTitle = 'EMPTY_TITLE',
    LongTitle = 'LONG_TITLE',
    DuplicateTitle = 'DUPLICATE_TITLE',
    InvalidExpiredDateAndPrisePerClick = 'INVALID_EXPIRED_DATE_AND_PRICE_PER_CLICK',
}
